import { DataView } from 'primereact/dataview';
import { SelectButton } from 'primereact/selectbutton';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { CONSTANT } from '../../../../utils/constants';
import HighlightDetail from './HighlightDetail';
import HighlightItem from './HighlightItem';
import HighlightManager from './HighlightManager';
import DocumentPanel from '../../common/document/DocumentPanel';
import styles from "../../../../components/Display/Wrapper.module.scss";

function HighlightPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const { setActiveView, navigationContext } = useNavigationContext();
  const [highlightList, setHighlightList] = useState([]);
  const [highlightDetail, setHighlightDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [typeFilter, setTypeFilter] = useState('highlight');
  const [duplicationMode, setDuplicationMode] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(undefined);
  const [documentManagerIsOpen, setDocumentManagerIsOpen] = useState(false);
  const [layout, setLayout] = useState('grid');

  useEffect(() => {
    fetchHighlightList();
  }, [typeFilter]);

  const fetchHighlightList = async () => {
    await privateFetch(
      'GET',
      'quatrebis',
      `/cu/${accountContext.id}/highlight/?type=${typeFilter || ''}`
    ).then((res) => {
      setHighlightList(res);
    });
  };

  useEffect(() => {
    fetchHighlightList();
  }, [navigationContext]);

  const fetchHighlightDetail = async () => {
    await privateFetch(
      'GET',
      'quatrebis',
      `/cu/${accountContext.id}/highlight/${navigationContext.activeHighlightId}/`
    ).then((res) => {
      if (res) setHighlightDetail(res);
    });
  };

  const handleClickHighlight = (highlight) => {
    setActiveView("qbhighlight", highlight, "activeHighlightId");
  };

  useEffect(() => {
    if (panelIsOpen === false) {
      setDuplicationMode(false) && setHighlightDetail(undefined);
    }
  }, [panelIsOpen]);

  const handleDuplicateHighlight = (highlight) => {
    handleOpenManager();
    setDuplicationMode(true);
    handleClickHighlight(highlight);
  };

  useEffect(() => {
    if (navigationContext.activeHighlightId) {
      fetchHighlightDetail();
    } else setHighlightDetail(undefined);
  }, [navigationContext]);

  const goBackHighlightAction = {
    onClick: handleClickHighlight,
    label: 'Retour à la liste',
    icon: 'pi pi-arrow-left'
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const newHighlightAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un temps fort / Alumni',
    icon: 'pi-plus'
  };

  const createHighlight = async (highlightForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'quatrebis',
      `/cu/${accountContext.id}/highlight/`,
      'Le Temps-fort / Alumni a bien été ajouté',
      JSON.stringify(highlightForm)
    ).then(() => {
      fetchHighlightList();
      setPanelIsOpen(false);
      setLoading(false);
      setDuplicationMode(false);
      setHighlightDetail(undefined);
    });
  };

  const updateHighlight = async (highlightForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'quatrebis',
      `/cu/${accountContext.id}/highlight/${highlightDetail.id}/`,
      'Le Temps-fort / Alumni a bien été modifié',
      JSON.stringify(highlightForm)
    ).then(() => {
      fetchHighlightList();
      setPanelIsOpen(false);
      fetchHighlightDetail(highlightDetail.id);
      setLoading(false);
    });
  };

  const deleteHighlight = async (highlight) => {
    await privateFetch(
      'DELETE',
      'quatrebis',
      `/cu/${accountContext.id}/highlight/${highlight.id}/`,
      'Le Temps-fort / Alumni a bien été supprimé'
    ).then(() => {
      fetchHighlightList();
      setHighlightDetail(undefined);
    });
  };

  const handleCreateDocument = () => {
    setSelectedDocument(undefined);
    setDocumentManagerIsOpen(true);
  };

  const handleUpdateDocument = (document) => {
    setSelectedDocument(document);
    setDocumentManagerIsOpen(true);
  };

  const uploadHighlightDocument = async (documentForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'quatrebis',
      `/cu/${accountContext.id}/highlight/${highlightDetail.id}/file/`,
      'Le fichier a bien été enregistré',
      documentForm,
      false,
      true
    ).then(() => {
      fetchHighlightDetail();
      setLoading(false);
      setDocumentManagerIsOpen(false);
    });
  };

  const updateDocument = async (documentForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/file/${selectedDocument.id}/`,
      'Le document a bien été modifié',
      documentForm,
      false,
      true
    ).then(() => {
      fetchHighlightDetail();
      setLoading(false);
      setDocumentManagerIsOpen(false);
    });
  };

  const handleDeleteDocument = async (document) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/file/${document.id}/`,
      'Le document a bien été supprimé'
    ).then(() => {
      fetchHighlightDetail();
      setSelectedDocument(undefined);
    });
  };



  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == "grid" ? "pi-list" : 'pi-th-large'
  };




  const highlightFilters = (
    <div className={styles.filterList}>
      <SelectButton
        value={typeFilter}
        onChange={(e) => setTypeFilter(e.value)}
        options={CONSTANT.quatrebis.highlightType}
        className={styles.switchButton}
      />
    </div>

  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Temps forts / Alumni"
        labelAction={handleClickHighlight}
        actions={highlightDetail ? [goBackHighlightAction] : [changeLayoutAction, newHighlightAction]}
        detail={highlightDetail}>
        {highlightDetail && !duplicationMode ? (
          <HighlightDetail
            highlight={highlightDetail}
            handleUpdateHighlight={handleOpenManager}
            handleDelete={deleteHighlight}
            handleCreateFile={handleCreateDocument}
            handleUpdateFile={handleUpdateDocument}
            handleDeleteFile={handleDeleteDocument}
          />
        ) : (
          <>
            {highlightFilters}

            <div className={styles.pageContentContainer}>
              <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
                {highlightList.map((highlight, index) => (
                  <HighlightItem
                    layout={layout}
                    key={index}
                    highlight={highlight}
                    handleClickHighlight={() => handleClickHighlight(highlight)}
                    handleDuplicateHighlight={() => handleDuplicateHighlight(highlight)}
                  />))}
              </div>
            </div>
          </>
        )}
      </PageWrapper>
      <HighlightManager
        isOpen={panelIsOpen}
        onClose={() => {
          setDuplicationMode(false);
          setPanelIsOpen(false);
        }}
        highlight={highlightDetail}
        onCreate={createHighlight}
        onUpdate={updateHighlight}
        loading={loading}
        duplicationMode={duplicationMode}
        setPanelIsOpen={setPanelIsOpen}
        setHighlightDetail={setHighlightDetail}
      />
      <DocumentPanel
        document={selectedDocument}
        loading={loading}
        isOpen={documentManagerIsOpen}
        onClose={() => {
          setSelectedDocument(null);
          setDocumentManagerIsOpen(false);
        }}
        onCreate={uploadHighlightDocument}
        onUpdate={updateDocument}
      />
    </div>
  );
}

export default HighlightPage;
